export default __webpack_public_path__ + "static/media/55_Sojka_obecna_cmmj_upr_thumb-min.fbebcd02.jpg";